export enum BikeForSaleStatus {
  CREATED = "CREATED",
  TO_BE_SERVICED = "TO_BE_SERVICED",
  WILL_NOT_BE_SERVICED = "WILL_NOT_BE_SERVICED",
  SERVICED = "SERVICED",
  BIKE_INFO_ADDED = "BIKE_INFO_ADDED",
  STORE_MATERIAL_CREATED = "STORE_MATERIAL_CREATED",
  ACCOUNTING_DOC_CREATED = "ACCOUNTING_DOC_CREATED",
  SOLD = "SOLD",
  SCRAPPED = "SCRAPPED",
  HANDED_OVER = "HANDED_OVER",
}

export const BIKE_FOR_SALE_ACTIVE_STATUSES = [
  BikeForSaleStatus.CREATED,
  BikeForSaleStatus.TO_BE_SERVICED,
  BikeForSaleStatus.WILL_NOT_BE_SERVICED,
] as const

export type BikeForSaleActiveStatus =
  (typeof BIKE_FOR_SALE_ACTIVE_STATUSES)[number]
